import {Box} from 'platform/foundation';

import i18n from '@dms/i18n';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function TechnicalInspectionSubSection() {
  return (
    <VFKit.SubSection
      data-testid="technical-inspection-section"
      title={i18n.t('entity.vehicle.labels.technicalInspection')}
      useCard
    >
      <VFKit.Group data-testid="technical-inspection-fields" columns={[2, 2, 2, 3]}>
        <VFKit.TechnicalInspectionValidUntilDatePicker />
        <Box paddingTop={5} flexGrow={1}>
          <VFKit.IsAcceptableForTechnicalInspectionCheckbox />
        </Box>
      </VFKit.Group>
      <VFKit.TechnicalInspectionNoteTextarea />
    </VFKit.SubSection>
  );
}
